


export function toggleSidebar() {
    return dispatch => {
        dispatch({
            type: 'TOGGLE_SIDEBAR'
        })
    }
}